import { Button, Typography, Dialog, Box } from '@mui/material'
import LikertScale from 'components/molecules/LikertScale'
import colors from 'styles/colors'
import LinearProgressBar from 'components/atoms/LinearProgressBar'
import InCardStack, { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { TaskSuccessIcon } from 'components/atoms/Icons'
import {
  Welcome,
  DescWithInfoCards
} from 'components/atoms/container/HeaderWithInfoCards'
import { getPercentageDisplay } from 'utils/formatText'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useTranslation, Trans } from 'react-i18next'

const celebrate = require('assets/images/celebrateSmall.png')

export const AssessmentLikertScale = ({ ...props }) => {
  return (
    <LikertScale
      setValueFromOthers={true}
      paddingSX={{ paddingY: 0, paddingX: 8 }}
      containerSx={{
        width: '100%',
        padding: 0
      }}
      dividerSx={{
        width: '100%',
        left: 2,
        top: 18,
        borderColor: colors.Grey100
      }}
      formControlSx={{
        '& .MuiButtonBase-root': {
          width: 36,
          height: 36,
          margin: 0,
          '& .MuiSvgIcon-root': {
            fontSize: 36
          }
        },
        '& .MuiTypography-root': {
          fontWeight: 500,
          color: colors.MidnightTeal300,
          marginLeft: 2
        }
      }}
      {...props}
    />
  )
}

export const AssessmentProgressBar = ({ percentage, m, n }) => {
  const { t } = useTranslation()
  return (
    <ColStack spacing={4}>
      <RowStack justifyContent='space-between'>
        <Typography variant='body1Small'>
          {t('assessments.mOfN', {
            m,
            n
          })}
        </Typography>
        <Typography variant='body1Small'>
          {getPercentageDisplay(percentage, 0)}
        </Typography>
      </RowStack>
      <Box width='100%' flexGrow={1}>
        <LinearProgressBar
          value={percentage * 100}
          width='100%'
          barSx={{
            height: 10,
            backgroundColor: colors.MutedTeal300,
            borderRadius: 4,
            '& .MuiLinearProgress-bar': {
              borderRadius: 25,
              backgroundColor: colors.MidnightTeal400
            }
          }}
        />
      </Box>
    </ColStack>
  )
}

export const AssessmentNAButton = ({ selected = false, handleNAClick }) => {
  const { t } = useTranslation()
  return (
    <Button
      size='small'
      variant={selected ? 'contained' : 'outlined'}
      color={selected ? 'secondary' : 'muted'}
      sx={{
        borderRadius: 25,
        ...(selected && {
          border: `2px solid ${colors.GoldenYellow400} !important`,
          backgroundColor: colors.GoldenYellow50,
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.20)'
        })
      }}
      onClick={handleNAClick}
      data-testid='assessment-na-button'>
      <Typography
        variant='body1Small'
        color={selected ? 'primary' : 'textSecondary'}
        fontWeight={selected ? 600 : 400}>
        {t('assessments.naSkip')}
      </Typography>
    </Button>
  )
}

export const AssessmentCompletePopup = ({
  congratsDialogOpen,
  handleComplete,
  forInsightSurvey = false
}) => {
  const { t } = useTranslation()
  return (
    <Dialog open={congratsDialogOpen}>
      <InCardStack
        width={480}
        spacing={12}
        justifyContent='flex-end'
        padding={20}
        sx={{
          ...(!forInsightSurvey && {
            background: `url(${celebrate}) no-repeat`,
            backgroundSize: 'cover',
            backgroundPositionY: -170,
            paddingTop: '115px',
            paddingBottom: '40px'
          })
        }}>
        <TaskSuccessIcon size={72} />
        {!forInsightSurvey ? (
          <Typography variant='h2' textAlign='center'>
            {t('assessmentTimeline.completingSelfAssessment.part1')} <br />{' '}
            {t('assessmentTimeline.completingSelfAssessment.part2')}
          </Typography>
        ) : (
          <>
            <Typography variant='h2' textAlign='center'>
              {t('userInsightSurvey.surveySubmitted')}
            </Typography>

            <Typography textAlign='center'>
              <Trans i18nKey='userInsightSurvey.submittedDescription' />
            </Typography>
          </>
        )}
        <Button
          onClick={handleComplete}
          endIcon={forInsightSurvey ? <ArrowForwardIcon /> : null}>
          {!forInsightSurvey
            ? t('stepQuiz.reviewMyResults')
            : t('common.continue')}
        </Button>
      </InCardStack>
    </Dialog>
  )
}

export const AssessmentHeadWrapper = ({
  title,
  description,
  children,
  ...otherProps
}) => {
  return (
    <DescWithInfoCards
      welcomeElement={<Welcome title={title} description={description} />}
      {...otherProps}>
      {children}
    </DescWithInfoCards>
  )
}
